import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

// Extrai a mensagem de erro do backend (SistemaException devolve { mensagem }) com fallbacks.
const extrairMensagemErro = error =>
    error?.response?.data?.mensagem ||
    error?.response?.data?.message ||
    error?.message ||
    "Erro inesperado. Tente novamente."

// GET /pedido/{id} → PedidoPojo completo (mesmo shape que POST /pedido/editar consome).
// Usado para pré-carregar o formulário de edição com os valores atuais do pedido.
export const buscarPedidoParaEdicao = async (idPedido, authorization) => {
    try {
        const response = await api.get(`pedido/${idPedido}`, {
            headers: { "Content-Type": "application/json", Authorization: authorization },
        })
        return { retornoErro: 0, pedido: response.data }
    } catch (error) {
        RegistrarLogErro(error, "buscarPedidoParaEdicao", idPedido)
        return { retornoErro: 1, mensagem: extrairMensagemErro(error) }
    }
}

// POST /pedido/editar (body PedidoPojo). Devolve o PedidoPojo atualizado.
// Toda alteração é registrada no histórico do pedido pelo backend (evento "PedidoAlterado").
export const editarPedido = async (pedidoPojo, authorization) => {
    try {
        const response = await api.post("pedido/editar", pedidoPojo, {
            headers: { "Content-Type": "application/json", Authorization: authorization },
        })
        return { retornoErro: 0, pedido: response.data }
    } catch (error) {
        RegistrarLogErro(error, "editarPedido", { id: pedidoPojo?.id })
        return { retornoErro: 1, mensagem: extrairMensagemErro(error) }
    }
}
